import { computeInvoiceDelta, type LedgerInvoice } from '../utils/invoiceLedger';
import type { VdScenarioExpectation } from './vdScenario.types';

export const HARNESS_LINE_NET = 1000;
export const HARNESS_VAT_PCT = 0.2;
export const HARNESS_DEPOSIT_PCT = 0.4;
export const HARNESS_QUOTE_GROSS = 1200;
export const HARNESS_DEPOSIT_GROSS = 480;

export function expectAfterFirstAccept(invoices: LedgerInvoice[]): VdScenarioExpectation {
  return computeInvoiceDelta({
    settledContract: HARNESS_QUOTE_GROSS,
    invoices,
  });
}

export function expectBalanceAfterFinalIncrease(args: {
  invoices: LedgerInvoice[];
  settledContract: number;
}): VdScenarioExpectation {
  return computeInvoiceDelta({
    settledContract: args.settledContract,
    invoices: args.invoices,
  });
}

export function assertStep(
  id: string,
  label: string,
  ok: boolean,
  detail?: string,
): { id: string; label: string; status: 'pass' | 'fail'; detail?: string } {
  return { id, label, status: ok ? 'pass' : 'fail', detail };
}
